import { useContextState } from "../../../../../../../../../../hooks/theme"


export const useStyles = () => {
    const { colors: color } = useContextState()

    return {
        baseModal: {
            width: '800px',
            padding: 2,
            height: '800px',
        },
        closeSuccess: {
            width: '100%',
            display: 'flex',
            justifyContent: 'end'
        },
        containerBody: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            overflow: 'auto',
            scrollbarWidth: 'none',
            paddingTop:1
        },
        buttonsContainer: {
            marginTop: '20px',
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .back': {
                width: '80px',
                height: '36px',
            },
            '& .next': {
                borderRadius: '4px',
            },
        },
        title: {
            fontWeight: 'bold'
        },
        containerSuccess: {
            width: '100%',
            height: '100%',
            margin: 'auto',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
        },
    }
}